<app-ag-grid [rowCount]="rowCount$ | async"
             [paginationPageSize]="pageSize$ | async"
             rowModelType="serverSide"
             serverSideStoreType="partial"
             loadingOverlayComponent="customOverlayLoading"
             noRowsOverlayComponent="customOverlayNoRows"
             [nbRowsOptions]="[
              {key: 10, text: '10'},
              {key: 25, text: '25'},
              {key: 50, text: '50'},
              {key: 100, text: '100'}
            ]"
             [gridOptions]="gridOptions"
             [suppressContextMenu]="true"
             [defaultColDef]="defaultColDef"
             (gridReady)="gridReady($event)"
             (filterChanged)="tableChanged($event)"
             (rowClicked)="onDetails($event)"
             (firstDataRendered)="tableDataChanged($event)"
             (rowDataChanged)="tableDataChanged($event)"
             (sortChanged)="tableChanged($event)"
             (paginationPageSizedChanged)="onPaginationPageSizeChanged($event)">
  <ng-template #actions let-params>
    <div class="display-flex flex-align-center justify-content-end full-height">
      <button mat-icon-button
              class="mat-focus-indicator mat-icon-button mat-button-base mr-10">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </ng-template>
</app-ag-grid>
